import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateGmailTargetRootFolderEnabled = mutatorAction('updateGmailTargetRootFolderEnabled', function (targetRootFolderEnabled) {
    var store = connectedAccountsStore();
    store.connectGmailState.targetRootFolderEnabled = targetRootFolderEnabled;
});
//# sourceMappingURL=updateGmailTargetRootFolderEnabled.js.map